<div class="fund-inactivate-modal-wrap"
    [class.fund-inactivate-modal-wrap--active]="mode === 'inactivate'">
    <app-carbon-warning-modal [active]="mode === 'inactivate'"
        [title]="inactivationTitle" [customContent]="true"
        [confirmText]="inactivationConfirmText" cancelText="Cancelar"
        [loading]="submitting" [loadingText]="loadingText"
        [loadingConfirmText]="loadingConfirmText"
        [disableConfirm]="confirmDisabled"
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmInactivation.bind(this)"
        [cancelAction]="close.bind(this)" (onClose)="close()">
        <div class="fund-status-modal">
            <p class="fund-status-modal-subtitle">
                <ng-container *ngIf="isEditingInactivation">
                    Você está editando a inativação agendada do fundo
                </ng-container>
                <ng-container *ngIf="!isEditingInactivation">
                    Você está inativando o fundo
                </ng-container>
                <strong>{{ fundName }}</strong>
                <span>·</span> {{ fundDocument }}
            </p>

            <div class="fund-inactivate-alert" *ngIf="previewView as impact">
                <svg-icon src="assets/images/icon-warning.svg"></svg-icon>
                <div class="fund-inactivate-alert-content">
                    <p>
                        Ao inativar este fundo, os cedentes e cotistas vinculados
                        a ele também serão inativados automaticamente:
                    </p>
                    <div class="fund-inactivate-alert-grid">
                        <div>
                            <strong>Cedentes que serão inativados
                                ({{ impact.inactivatedAssignorsCount }})</strong>
                        </div>
                        <div>
                            <strong>Cotistas que serão inativados
                                ({{ impact.inactivatedShareholdersCount }})</strong>
                        </div>
                    </div>
                    <button type="button" class="fund-inactivate-alert-link"
                        *ngIf="hasInactivationImpactList"
                        (click)="openImpactListModal($event)">
                        <svg-icon src="assets/images/icon-eye.svg"></svg-icon>
                        Ver listagem
                    </button>
                </div>
            </div>

            <p class="fund-status-modal-hint" *ngIf="previewLoading">
                Consultando impacto da inativação...
            </p>

            <app-spacer [bottom]="16"></app-spacer>
            <app-select [items]="reasonItems" [group]="inactivateForm"
                controlName="reason" label="Motivo da inativação"
                placeholder="Selecione"
                [readOnly]="isEditingInactivation">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>

            <div class="fund-transfer-section" *ngIf="isTransferReason()">
                <strong>Dados da transferência — novo administrador (saída)</strong>
                <app-spacer [bottom]="16"></app-spacer>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <app-masked-input [group]="inactivateForm"
                            controlName="transfer_date" mask="00/00/0000"
                            label="Data de transferência" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-masked-input [group]="inactivateForm"
                            controlName="assembly_date" mask="00/00/0000"
                            label="Data assembleia" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>
                </div>

                <div class="fund-date-alert fund-date-alert--info"
                    *ngIf="transferDateTiming === 'future'">
                    <svg-icon src="assets/images/icon-info.svg"></svg-icon>
                    <div class="fund-date-alert-content">
                        <strong class="fund-date-alert-title">Inativação pré-agendada</strong>
                        <p>
                            A data de transferência é futura. O fundo permanecerá
                            ativo e será inativado automaticamente em
                            <strong>{{ transferDateDisplay }}</strong>, quando os
                            cedentes e cotistas vinculados também serão inativados.
                        </p>
                    </div>
                </div>

                <div class="fund-date-alert fund-date-alert--error"
                    *ngIf="transferDateTiming === 'today'">
                    <svg-icon src="assets/images/icon-times-circle.svg"></svg-icon>
                    <div class="fund-date-alert-content">
                        <strong class="fund-date-alert-title">Inativação imediata</strong>
                        <p>
                            A data de transferência é hoje. O fundo será
                            <strong>inativado imediatamente, neste momento</strong>,
                            junto com os cedentes e cotistas vinculados.
                        </p>
                    </div>
                </div>

                <div class="fund-date-alert fund-date-alert--error"
                    *ngIf="transferDateTiming === 'past'">
                    <svg-icon src="assets/images/icon-times-circle.svg"></svg-icon>
                    <div class="fund-date-alert-content">
                        <strong class="fund-date-alert-title">Inativação imediata</strong>
                        <p>
                            A data de transferência já passou. O fundo será
                            <strong>inativado imediatamente, neste momento</strong>,
                            junto com os cedentes e cotistas vinculados.
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <app-masked-input [group]="inactivateForm"
                            controlName="cnpj" documentType="cnpj" label="CNPJ"
                            placeholder="00.000.000/0000-00">
                        </app-masked-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-input [group]="inactivateForm"
                            controlName="company_name" label="Razão social"
                            placeholder="Digite">
                        </app-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-input [group]="inactivateForm"
                            controlName="contact_name" label="Nome do administrador"
                            placeholder="Digite">
                        </app-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-input type="email" [group]="inactivateForm"
                            controlName="email" label="E-mail" placeholder="Digite">
                        </app-input>
                    </div>
                    <div class="col-4 col-md-2">
                        <app-input [group]="inactivateForm" controlName="phone_ddi"
                            label="DDI" placeholder="+55">
                        </app-input>
                    </div>
                    <div class="col-8 col-md-4">
                        <app-masked-input [group]="inactivateForm"
                            controlName="phone" label="Telefone"
                            mask="(00) 00000-0000||(00) 0000-0000"
                            placeholder="Digite">
                        </app-masked-input>
                    </div>
                    <div class="col-4 col-md-2">
                        <app-input [group]="inactivateForm" controlName="mobile_ddi"
                            label="DDI" placeholder="+55">
                        </app-input>
                    </div>
                    <div class="col-8 col-md-4">
                        <app-masked-input [group]="inactivateForm"
                            controlName="mobile" label="Celular"
                            mask="(00) 00000-0000||(00) 0000-0000"
                            placeholder="Digite">
                        </app-masked-input>
                    </div>
                </div>
                <p class="fund-status-modal-hint">
                    Estas informações podem ser editadas depois na aba
                    Transferência do fundo.
                </p>
            </div>

            <ng-container *ngIf="!isTransferReason()">
                <app-input [group]="inactivateForm" controlName="justification"
                    label="Justificativa" [rows]="4"
                    placeholder="Descreva o motivo da inativação...">
                </app-input>
                <p class="fund-status-modal-hint">Mínimo de 10 caracteres.</p>
            </ng-container>
        </div>
    </app-carbon-warning-modal>
</div>

<div class="fund-immediate-confirm-wrap"
    [class.fund-immediate-confirm-wrap--active]="showImmediateConfirmModal">
    <app-carbon-warning-modal [active]="showImmediateConfirmModal"
        title="Atenção"
        message="Esta ação <strong>não poderá ser desfeita</strong>. O fundo será <strong>inativado imediatamente</strong>, junto com os cedentes e cotistas vinculados."
        confirmText="Confirmar inativação" cancelText="Cancelar"
        [loading]="submitting" [loadingText]="loadingText"
        [loadingConfirmText]="loadingConfirmText"
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmImmediateInactivation.bind(this)"
        [cancelAction]="closeImmediateConfirmModal.bind(this)"
        (onClose)="closeImmediateConfirmModal()">
    </app-carbon-warning-modal>
</div>

<div class="fund-impact-list-wrap"
    [class.fund-impact-list-wrap--active]="showImpactListModal">
    <app-carbon-warning-modal [active]="showImpactListModal"
        title="Cedentes e cotistas que serão inativados"
        [customContent]="true" confirmText="Fechar" cancelText=""
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="closeImpactListModal.bind(this)"
        (onClose)="closeImpactListModal()">
        <div class="fund-impact-list" *ngIf="previewView as impact">
            <div class="fund-impact-list-tabs">
                <button type="button" class="fund-impact-list-tab"
                    [class.fund-impact-list-tab--active]="impactListTab === 'assignors'"
                    (click)="setImpactListTab('assignors')">
                    Cedentes ({{ impact.inactivatedAssignorsCount }})
                </button>
                <button type="button" class="fund-impact-list-tab"
                    [class.fund-impact-list-tab--active]="impactListTab === 'shareholders'"
                    (click)="setImpactListTab('shareholders')">
                    Cotistas ({{ impact.inactivatedShareholdersCount }})
                </button>
            </div>

            <div class="fund-impact-list-table-wrap">
                <table class="fund-impact-list-table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Documento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of impactListItems">
                            <td>{{ item.nome }}</td>
                            <td>{{ formatPreviewDocument(item.documento) }}</td>
                        </tr>
                        <tr *ngIf="!impactListItems.length">
                            <td colspan="2" class="fund-impact-list-empty">
                                Nenhum registro para inativar
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </app-carbon-warning-modal>
</div>

<div class="fund-inactivate-modal-wrap"
    [class.fund-inactivate-modal-wrap--active]="mode === 'activate'">
    <app-carbon-warning-modal [active]="mode === 'activate'"
    title="Solicitar reativação" [customContent]="true"
    confirmText="Solicitar reativação" cancelText="Cancelar"
    [loading]="submitting" [loadingText]="loadingText"
    [loadingConfirmText]="loadingConfirmText"
    [disableConfirm]="confirmDisabled"
    [skipAutoCloseOnConfirm]="true"
    [confirmAction]="confirmActivation.bind(this)"
    [cancelAction]="close.bind(this)" (onClose)="close()">
    <div class="fund-status-modal">
        <p class="fund-status-modal-subtitle">
            Você está solicitando a reativação do fundo
            <strong>{{ fundName }}</strong>
            <span>·</span> {{ fundDocument }}
        </p>
        <div class="fund-activate-info-alert">
            <svg-icon src="assets/images/icon-info.svg"></svg-icon>
            <p>
                Ao solicitar a reativação, o fundo passará
                <strong>novamente pelo processo de aprovação</strong>.
                O status volta para <strong>Em aprovação</strong>.
            </p>
        </div>
        <div class="fund-current-inactivation" *ngIf="currentInactivation as current">
            <strong class="fund-current-inactivation-title">Inativação atual</strong>
            <div class="fund-current-inactivation-grid">
                <div class="fund-current-inactivation-item">
                    <span class="fund-current-inactivation-label">Motivo</span>
                    <span class="fund-current-inactivation-value">{{ reasonLabel(current.reason) }}</span>
                </div>
                <div class="fund-current-inactivation-item">
                    <span class="fund-current-inactivation-label">Data</span>
                    <span class="fund-current-inactivation-value">{{ current.date || '-' }}</span>
                </div>
            </div>
            <div class="fund-current-inactivation-item" *ngIf="current.reason === 'transfer'">
                <span class="fund-current-inactivation-label">Transferido para</span>
                <span class="fund-current-inactivation-value">
                    {{ getTransferDestinationDisplay(current) }}
                </span>
            </div>
            <div class="fund-current-inactivation-item" *ngIf="current.reason !== 'transfer'">
                <span class="fund-current-inactivation-label">Justificativa</span>
                <span class="fund-current-inactivation-value">{{ inactivationJustification() }}</span>
            </div>
        </div>
        <app-spacer [bottom]="16"></app-spacer>
        <app-select [items]="activateReasonItems" [group]="activateForm"
            controlName="reason" label="Motivo da reativação"
            placeholder="Selecione">
        </app-select>
        <app-spacer [bottom]="16"></app-spacer>

        <div class="fund-transfer-section" *ngIf="isActivationTransferReason()">
            <strong>Dados da transferência — administrador anterior (entrada)</strong>
            <app-spacer [bottom]="16"></app-spacer>
            <div class="row">
                <div class="col-12 col-md-6">
                    <app-masked-input [group]="activateForm"
                        controlName="cnpj" documentType="cnpj" label="CNPJ"
                        placeholder="00.000.000/0000-00">
                    </app-masked-input>
                </div>
                <div class="col-12 col-md-6">
                    <app-input [group]="activateForm"
                        controlName="company_name" label="Razão social"
                        placeholder="Digite">
                    </app-input>
                </div>
                <div class="col-12 col-md-6">
                    <app-input type="email" [group]="activateForm"
                        controlName="email" label="E-mail" placeholder="Digite">
                    </app-input>
                </div>
            </div>
            <div class="row">
                <div class="col-4 col-md-2">
                    <app-input [group]="activateForm" controlName="phone_ddi"
                        label="DDI" placeholder="+55">
                    </app-input>
                </div>
                <div class="col-8 col-md-4">
                    <app-masked-input [group]="activateForm"
                        controlName="phone" label="Telefone"
                        mask="(00) 00000-0000||(00) 0000-0000"
                        placeholder="Digite">
                    </app-masked-input>
                </div>
                <div class="col-4 col-md-2">
                    <app-input [group]="activateForm" controlName="mobile_ddi"
                        label="DDI" placeholder="+55">
                    </app-input>
                </div>
                <div class="col-8 col-md-4">
                    <app-masked-input [group]="activateForm"
                        controlName="mobile" label="Celular"
                        mask="(00) 00000-0000||(00) 0000-0000"
                        placeholder="Digite">
                    </app-masked-input>
                </div>
            </div>
        </div>

        <ng-container *ngIf="!isActivationTransferReason()">
            <app-input [group]="activateForm" controlName="justification"
                label="Justificativa da reativação" [rows]="4"
                placeholder="Descreva o motivo da reativação deste fundo...">
            </app-input>
            <p class="fund-status-modal-hint">
                Obrigatório. Entre 10 e 500 caracteres. Fica registrada no histórico do fundo.
            </p>
        </ng-container>
    </div>
    </app-carbon-warning-modal>
</div>
